import { billingInfo, User } from "../../types/user.types";

export const transformbillingInfo = (data: any): billingInfo => ({
  level: data?.level,
  reportCount: data?.report_count,
  searchesCount: data?.searches_count,
  tokensCount: data?.tokens_count,
  removalsUsed: data?.removals_used,
  removalsCap: data?.removals_cap,
  removalsRemaining: data?.removals_remaining,
  // 'active' | 'past_due' | 'suspended' — 'suspended' = account bloccato per mancato pagamento
  billingStatus: data?.billing_status,
});

export const transformUser = (data: any): User => ({
  email: data?.email,
  firstName: data?.firstName,
  id: data?.id,
  lastName: data?.lastName,
  role: data?.role,
  verified: data?.verified,
  billingInfo: transformbillingInfo(data.billing_info),
  subscriptions: data?.subscriptions,
});

export const transformUserAdmin = (data: any): User => ({
  email: data?.email,
  firstName: data?.name,
  id: data?.id,
  lastName: data?.lastname,
  role: data?.role,
  verified: data?.verified,
  billingInfo: transformbillingInfo(data.billing),
  subscriptions: data?.subscriptions,
});
